/* eslint-disable @typescript-eslint/naming-convention -- Enum variable case matters. */
export enum ErrorCodeExplanations {
  tec = 'Claimed cost only: The transaction did not achieve its intended purpose, but the transaction cost was destroyed. This result is only final in a validated ledger.',
  tef = "Failure: The transaction cannot be applied to the server's current (in-progress) ledger or any later one.",
  tel = 'Local error: The rippled server had an error due to local conditions, such as high load. You may get a different response if you resubmit to a different server or at a different time.',
  tem = 'Malformed transaction: The transaction was not valid, due to improper syntax, conflicting options, a bad signature, or something else.',
  ter = 'Retry: The transaction could not be applied, but it could apply successfully in a future ledger.',
  tes = 'Success: The transaction succeeded. This result only final in a validated ledger.',
}

/**
 * Looks up the error message corresponding to the error code.
 *
 * @param result - The error code (or success code) included in the metadata.
 *
 * @returns The corresponding error message for the error code.
 */
export default function lookupErrorCode(result: string): string {
  const error = Object.entries(ErrorCodeExplanations).find(([code]) =>
    result.startsWith(code),
  )

  if (!error) {
    return 'Unknown error type'
  }
  return error[1]
}
